import { appInfo } from "./appInfo.const";

export const apiUrls = {

    // public apis
    locations: `${appInfo.locationUrl}`,
    login: `${appInfo.authUrl}/login`,
    refresh: `${appInfo.authUrl}/refresh`,
    register: `${appInfo.authUrl}/register`,
    categorization: `${appInfo.baseUrl}/categorization`,
    serviceProviders: `${appInfo.baseUrl}/service-providers`,
    serviceItems: `${appInfo.baseUrl}/service-items`,
    serviceItemsSearch: `${appInfo.baseUrl}/search-items`,
    clientItems: `${appInfo.baseUrl}/client-items`,
    clientInfo: `${appInfo.baseUrl}/client-info`,
    serviceItemDetails: `${appInfo.baseUrl}/get-item-details/`,
    faq: `${appInfo.baseUrl}/faq`,
    termsConditions: `${appInfo.baseUrl}/terms-conditions`,
    agreement: `${appInfo.baseUrl}/agreement`,
    privacyPolicy: `${appInfo.baseUrl}/privacy-policy`,
    query: `${appInfo.baseUrl}/query`,
    aboutUs: `${appInfo.baseUrl}/about-us`,
    checkBusinessName: `${appInfo.baseUrl}/check-business-name`,
    checkAndGetUserByMobileNoOrEmail: `${appInfo.authUrl}/check-&-get-user-by-mobile-no-or-email`,
    getFaqs: `${appInfo.baseUrl}/faqs`,

    // auth apis
    user: `${appInfo.authUrl}/user`,
    updateAccount: `${appInfo.authUrl}/update-account`,
    logout: `${appInfo.authUrl}/logout`,
    profile: `${appInfo.authUrl}/profile`,
    updateProfile: `${appInfo.authUrl}/update-profile`,
    updatePhoto: `${appInfo.authUrl}/update-photo`,

    // busniess apis
    getBusinesses: `${appInfo.baseUrl}/business-by-user`,
    storeBusiness: `${appInfo.baseUrl}/create-business`,
    
    // location apis
    getStoredLocation: `${appInfo.authUrl}/get-stored-location`,
    saveLocation: `${appInfo.authUrl}/store-user-location`,
    activateLocation: `${appInfo.authUrl}/activate-stored-location`,
    deleteLocation: `${appInfo.authUrl}/delete-stored-location`,

    // booking apis
    businessServicesCategories: `${appInfo.baseUrl}/business-service-categories`,
    businessServiceItems: `${appInfo.baseUrl}/business-service-items/`,
    createBooking: `${appInfo.baseUrl}/create-booking`,
    getBookings: `${appInfo.baseUrl}/bookings`,
    bookingDetails: (bookingId: string) => `${appInfo.baseUrl}/booking/${bookingId}`,

    // dashboard apis
    // dashboard: (code: string) => `${appInfo.baseUrl}/dashboard/${code}`,
    // businessInfo: (code: string) => `${appInfo.baseUrl}/dashboard/${code}/business-info`,
    // updateBusinessInfo: (code: string) => `${appInfo.baseUrl}/dashboard/${code}/business-info/update`,
    // businessSettings: (code: string) => `${appInfo.baseUrl}/dashboard/${code}/business-settings`,
    // updateBusinessSettings: (code: string) => `${appInfo.baseUrl}/dashboard/${code}/business-settings/update`
};
